import { FirebaseError } from 'firebase/app';

export function formatFirestoreError(error: unknown): string {
  if (error instanceof FirebaseError) {
    switch (error.code) {
      case 'permission-denied':
        return 'Firestore denied access. Deploy firebase/firestore.rules to your Firebase project (see firebase/FIREBASE_SETUP.md).';
      case 'unavailable':
        return 'Firestore is unavailable. Check your network and Firebase project status.';
      case 'failed-precondition':
        return 'Firestore is not set up yet. Create a Firestore database in the Firebase Console.';
      default:
        return error.message || error.code;
    }
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'Unknown error';
}
